<template>
  <div>
    <el-card v-loading="loading">
      <div slot="header" class="clearfix">
        <span>基本信息</span>
      </div>

      <el-row>
        <el-col :span="18">
          <el-descriptions :column="2" :contentStyle="{ height: '31px' }">
            <el-descriptions-item label="姓名">
              {{ info.mavinName }}
            </el-descriptions-item>

            <el-descriptions-item label="性别">
              {{ info.sex }}
            </el-descriptions-item>

            <el-descriptions-item label="民族">
              {{ info.nation }}
            </el-descriptions-item>

            <el-descriptions-item label="政治面貌">
              {{ info.clan }}
            </el-descriptions-item>

            <el-descriptions-item label="出生年月">
              {{ moment(info.birthday).format('YYYY-MM-DD') }}
            </el-descriptions-item>

            <el-descriptions-item label="参加工作时间">
              {{ moment(info.workTime).format('YYYY-MM-DD') }}
            </el-descriptions-item>

            <el-descriptions-item label="籍贯">
              {{ info.bornName }}
            </el-descriptions-item>

            <el-descriptions-item label="人员状态">
              {{ info.state }}
            </el-descriptions-item>

            <el-descriptions-item label="主要从事的专业方向（研究学科）">
              {{ info.speName }}/{{ info.minorName }}
            </el-descriptions-item>

            <el-descriptions-item label="身份证号码">
              {{ info.idCard }}
            </el-descriptions-item>

            <el-descriptions-item label="人员行业分类">
              {{ info.industry }}
            </el-descriptions-item>
            <el-descriptions-item label="毕业学校">
              {{ info.school }}
            </el-descriptions-item>
            <el-descriptions-item label="所学专业">
              {{ info.profession }}
            </el-descriptions-item>
            <el-descriptions-item label="学历">
              {{ info.education }}
            </el-descriptions-item>
            <el-descriptions-item label="学位">
              {{ info.degree }}
            </el-descriptions-item>
            <el-descriptions-item label="健康状况">
              {{ info.healthy }}
            </el-descriptions-item>
            <el-descriptions-item label="手机号码">
              {{ info.mobile }}
            </el-descriptions-item>
            <el-descriptions-item label="电子邮箱">
              {{ info.email }}
            </el-descriptions-item>
          </el-descriptions>
        </el-col>        
        <el-col :span="6">
          <div class="panel-card">
            <attach ref="Attach"></attach>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="clearfix">
        <span>工作信息</span>
      </div>

      <el-row>
        <el-col :span="24">
          <el-descriptions :column="2" :labelStyle="{ height: '31px' }">
            <el-descriptions-item label="工作单位">
              {{ info.deptName }}
            </el-descriptions-item>

            <el-descriptions-item label="单位隶属层级">
              {{ info.affiliationLevel }}
            </el-descriptions-item>

            <el-descriptions-item label="进入现单位工作时间">
              {{ moment(info.deptWorkTime).format('YYYY-MM-DD') }}
            </el-descriptions-item>

            <el-descriptions-item label="专业技术职称">
              {{ info.appellation }}
            </el-descriptions-item>

            <el-descriptions-item label="职称取得时间">
              {{ moment(info.appellationDate).format('YYYY-MM-DD') }}
            </el-descriptions-item>

            <el-descriptions-item label="现聘岗位名称（职务）">
              {{ info.headship }}
            </el-descriptions-item>

            <el-descriptions-item label="行政级别">
              {{ info.executLevel }}
            </el-descriptions-item>

            <el-descriptions-item label="现聘岗位等级">
              {{ info.jobLevel }}
            </el-descriptions-item>

            <el-descriptions-item label="现聘岗位等级时间">
              {{ info.jobTimeStr }}
            </el-descriptions-item>

            <el-descriptions-item label="兼聘双肩挑岗位等级">
              {{ info.dualityJobLevel }}
            </el-descriptions-item>

            <el-descriptions-item label="兼聘双肩挑岗位等级时间">
              {{ info.dualityJobTimeStr }}
            </el-descriptions-item>

            <el-descriptions-item
              label="前期是否在事业单位聘用专业技术二级岗位"
            >
              {{ info.hireState }}
            </el-descriptions-item>

            <el-descriptions-item label="前期入选专业技术二级岗位聘用条件"
              span="2">
              {{ info.employConditon }}
            </el-descriptions-item>

            <el-descriptions-item
              label="聘用正高级岗位以来的主要业绩、贡献和成果"
            >
              {{ info.practFruit }}
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
  
<script>
import Attach from './Attach.vue';
import { getReview } from '@/api/position/mavin/base.js';

export default {
  data() {
    return {
      loading: false,
      title: '办理界面',
      info: {}
    };
  },
  components: {
    Attach
  },
  methods: {
    getData(mavinEid) {
      this.loading = true;
      getReview(mavinEid)
        .then(res => {
          this.info = res;
          this.$emit('set-title', `${res.mavinName}-${res.mobile}`);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      window.close();
    }
  },
  created() {
    this.getData(this.$route.params.mavinEid);
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin-top: 10px;
}
</style>  
<style>
.el-descriptions-item__content {
  font-weight: 600;
}

.head-face {
  height: 220px;
  margin-left: 150px;
}
</style>